import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { IUserInfo } from '../interfaces/user.interface';

import { HttpBaseApi } from './base-http.api';
import { SKIP_ERROR_TOAST } from './error.iterceptor';

@Injectable({ providedIn: 'root' })
export class UserApi extends HttpBaseApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _endpoint = 'users';

  public getInfoByToken(): Observable<IUserInfo> {
    return this._httpClient.get<IUserInfo>(this.buildUrl(`${this._endpoint}/info/by-token`));
  }

  /** Своё фото (CRM-124): `file` — уже уменьшенное, `null` — убрать. Ответ — новая версия. Без тоста: ошибка в окне. */
  public setMyPhoto(file: Blob | null): Observable<string | undefined> {
    const url = this.buildUrl(`${this._endpoint}/me/photo`);
    const context = new HttpContext().set(SKIP_ERROR_TOAST, true);
    if (!file) return this._httpClient.delete<void>(url, { context }).pipe(map(() => undefined));
    const form = new FormData();
    form.append('file', file, 'photo.jpg');
    return this._httpClient.put<{ photoId: string }>(url, form, { context }).pipe(map((x) => x.photoId));
  }
}
